export const APP_NAME = 'Backups.so'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export const NOTION_REDIRECT_URI =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
        ? `${window.location.origin}/auth/notion`
        : 'https://app.backups.so/auth/notion'

export const NOTION_AUTH_URL = `https://api.notion.com/v1/oauth/authorize?client_id=d9192303-12f4-46fe-812c-c42e35bc0d88&response_type=code&owner=user&redirect_uri=${encodeURIComponent(NOTION_REDIRECT_URI)}`
